import { useMutation } from '@tanstack/react-query';
import { osmPost } from '@/api/osmClient';
import type { VroomRequest, VroomResponse } from '@/types/osm';

export function useOsmVroom() {
  return useMutation<VroomResponse, Error, VroomRequest>({
    mutationFn: (req) =>
      osmPost<VroomResponse, VroomRequest>('/vroom', { ...req, options: { g: true, ...(req.options ?? {}) } }),
  });
}
